export const LorenAssetResolverConstant = {
    ASSET_ID: 'asset',
    ASSETS: 'assets'
};
